import { Injectable } from '@angular/core';
import { SsoUserCreationRequest } from '../interfaces/sso-user-creation-request';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class UniversalIdFormStateService {
    private formDataSubject = new BehaviorSubject<Partial<SsoUserCreationRequest> | null>(null);

    setFormState(data: Partial<SsoUserCreationRequest>) {
        this.formDataSubject.next(data);
    }

    getFormData(): Partial<SsoUserCreationRequest> | null {
        return this.formDataSubject.value;
    }

    getFormData$(): Observable<Partial<SsoUserCreationRequest> | null> {
        return this.formDataSubject.asObservable();
    }

    clearFormState(): void {
        this.formDataSubject.next(null);
    }
}
